import { ResultsCard } from './ResultCard'
import { SkeletonCard } from './SkeletonCard'
import { ResultUpsellCard } from './ResultUpsellCard'
import { SkeletonUpsellCard } from './SkeletonUpsellCard'

export const CARD_STYLES = {
  default: { CardComponent: ResultsCard, SkeletonComponent: SkeletonCard },
  upsell: { CardComponent: ResultUpsellCard, SkeletonComponent: SkeletonUpsellCard }
}

export const getCardStyle = (style) => CARD_STYLES[style] || CARD_STYLES.default
